import React, { useState } from 'react';
import { Box, Container, Typography, Link, Stack } from '@mui/material';
import LocalBarIcon from '@mui/icons-material/LocalBar';
import EmailIcon from '@mui/icons-material/Email';
import TermsDialog from './TermsDialog';
import { useCityContext } from '../contexts/CityContext';

const Footer = ({ onSuggestDeal }) => {
  const { city } = useCityContext();
  const [termsOpen, setTermsOpen] = useState(false);

  const handleTermsOpen = () => {
    setTermsOpen(true);
  };

  const handleTermsClose = () => {
    setTermsOpen(false);
  };

  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        mt: 'auto',
        backgroundColor: '#2D2A26',
        color: 'rgba(255, 255, 255, 0.9)',
      }}
    >
      <Container maxWidth="lg">
        {/* Main footer content */}
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'center', sm: 'flex-start' }}
          spacing={3}
        >
          {/* Brand section */}
          <Box sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: { xs: 'center', sm: 'flex-start' }, gap: 1, mb: 1 }}>
              <LocalBarIcon sx={{ color: '#F59E0B', fontSize: 24 }} />
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  color: '#F59E0B',
                  letterSpacing: '-0.5px'
                }}
              >
                {city.displayName}
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.6)', fontSize: '0.8rem' }}>
              Discover the best happy hour deals
            </Typography>
          </Box>

          {/* Contact section */}
          <Box sx={{ textAlign: { xs: 'center', sm: 'right' } }}>
            <Link
              href={`mailto:${city.contactEmail}`}
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                color: 'rgba(255, 255, 255, 0.8)',
                textDecoration: 'none',
                fontSize: '0.875rem',
                transition: 'color 0.2s',
                '&:hover': {
                  color: '#F59E0B'
                }
              }}
            >
              <EmailIcon sx={{ fontSize: 18 }} />
              Contact Us
            </Link>
          </Box>
        </Stack>

        {/* Divider */}
        <Box
          sx={{
            my: 2,
            borderTop: '1px solid rgba(255, 255, 255, 0.1)'
          }}
        />

        {/* Bottom row */}
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems="center"
          spacing={1}
        >
          <Typography
            variant="body2"
            sx={{
              color: 'rgba(255, 255, 255, 0.5)',
              fontSize: '0.75rem'
            }}
          >
            © {new Date().getFullYear()} {city.displayName}. All rights reserved.
          </Typography>

          <Stack
            direction="row"
            spacing={2}
            sx={{
              '& a, & button': {
                color: 'rgba(255, 255, 255, 0.5)',
                fontSize: '0.75rem',
                textDecoration: 'none',
                transition: 'color 0.2s',
                '&:hover': {
                  color: '#F59E0B'
                }
              }
            }}
          >
            <Link
              href={city.privacyUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </Link>
            <Link
              component="button"
              onClick={handleTermsOpen}
              sx={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: 0
              }}
            >
              Terms of Use
            </Link>
          </Stack>
        </Stack>
      </Container>

      <TermsDialog open={termsOpen} onClose={handleTermsClose} />
    </Box>
  );
};

export default Footer;
